export type ArrayInsertAtIndexArgs<T> = {
  array: T[];
  item: T;
  index: number;
};

export const arrayInsertAtIndex = <T = unknown>({
  array,
  item,
  index,
}: ArrayInsertAtIndexArgs<T>): T[] => {
  if (!Array.isArray(array) || !Number.isFinite(index)) {
    return [];
  }

  return [...array.slice(0, index), item, ...array.slice(index)];
};
